import EvaluateResult from "../../EvaluateResult"
import { DecisionReason, Variation } from "../../../model/model"
import ExperimentLocalEvaluateRequest from "../../service/experiment/mode/local/ExperimentLocalEvaluateRequest"
import ObjectUtil from "../../../util/ObjectUtil"

export interface ExperimentEvaluateResult extends EvaluateResult {
  variation: Variation

  with(reason: DecisionReason): ExperimentEvaluateResult
}

class DefaultExperimentEvaluateResult implements ExperimentEvaluateResult {
  constructor(readonly reason: DecisionReason, readonly variation: Variation) {}

  with(reason: DecisionReason): ExperimentEvaluateResult {
    return new DefaultExperimentEvaluateResult(reason, this.variation)
  }
}

// Merged with the interface above so `ExperimentEvaluateResult.of(...)` keeps working as a value.
export const ExperimentEvaluateResult = {
  of(reason: DecisionReason, variation: Variation): ExperimentEvaluateResult {
    return new DefaultExperimentEvaluateResult(reason, variation)
  },

  ofControl(reason: DecisionReason, request: ExperimentLocalEvaluateRequest): ExperimentEvaluateResult {
    const variation = request.experiment._getVariationByKeyOrNull("A")
    if (ObjectUtil.isNullOrUndefined(variation)) {
      throw new Error(`Control variation(A) not found for experiment [key=${request.experiment.key}]`)
    }
    return this.of(reason, variation)
  }
}
